import { makeStyles } from '@material-ui/core/styles';
import { themeCommon } from '../../../styles/theme'

const useStyles = makeStyles((theme) => ({
    separator: {
        color: '#1D1D1D',
    },
    root: {
        border: '1px solid #2F2F2F',
        color: '#2F2F2F',
        fontSize: themeCommon.fontSize18px,
        borderRadius: '10px',
        opacity: 0.3,
        // padding: '0 30px',
        height: '50px',
        cursor: 'pointer',
        width: 'fit-content',
        [theme.breakpoints.down('md')]: {
            height: '40px',
            width: '60px',
            fontSize: themeCommon.fontSize16px,
        },
        [theme.breakpoints.down('sm')]: {
            height: '30px',
            fontSize: themeCommon.fontSize14px,
        },
        [theme.breakpoints.down('xs')]: {
            height: '30px',
            fontSize: themeCommon.fontSize12px,
        },
    },
    ol: {
        '& > li': {
            paddingRight: '5px',
            margin: 0,
            marginBottom: '5px',
            height: '50px',
            display: 'flex',
            alignItems: 'center',
            [theme.breakpoints.down('md')]: {
                height: '40px',
            },
            [theme.breakpoints.down('sm')]: {
                height: '30px',
            },
            [theme.breakpoints.down('xs')]: {
                height: '30px',
            },
        },
        '& > li + .MuiButtonBase-root': {
            background: '#FFFFFF',
            border: '1px solid #2F2F2F',
            borderRadius: '10px',
            padding: '0 5px',
            opacity: 0.3,
            // disable onClick breadcrumb ...
            // pointerEvents: 'none',
        }
    },
    activeLight: {
        background: `${themeCommon.lightBlue} !important`,
        border: `1px solid ${themeCommon.lightBlue} !important`,
    },
    active: {
        background: '#0C8FAD',
        border: '1px solid #0C8FAD',
        fontFamily: themeCommon.RobotoBold,
        color: "#FFFFFF",
        height: '50px',
        opacity: 1,
        cursor: 'unset',
        width: '200px',
        position: 'relative',
        overflow: 'hidden',
        padding: '0 20px',
        [theme.breakpoints.down('lg')]: {
            width: '180px',
        },
        [theme.breakpoints.down('md')]: {
            height: '40px',
            width: '125px',
        },
        [theme.breakpoints.down('sm')]: {
            height: '30px',
        },
        [theme.breakpoints.down('xs')]: {
            height: '30px',
        },
    },
    labelActive: {
        // whiteSpace: 'nowrap',
        // animation: '$floatText 7s infinite alternate',
        // position: 'absolute',
        // '&:hover': {
        //     animationPlayState: 'paused',
        // }
    },
    activeRunText: {
        whiteSpace: 'nowrap',
        animation: '$floatText 7s infinite alternate',
        position: 'absolute',
        '&:hover': {
            animationPlayState: 'paused',
        }
    },
    "@keyframes floatText": {
        'from': {
            transform: 'translateX(100%)',
            right: '100%',
        },
        'to': {
            transform: 'translateX(0%)',
            right: '0%',
        },
    }
}), {
    name: 'BreadCrumbHeadContainer',
    index: 1,
})

export default useStyles;